{
  "Clear search": "Notīrīt meklēšanu"
}